export default {
  placeholderTitle:
    'components.views.generate-diecut-view.diecut-list.placeholder'
}
